<template>
  <div class="s-albums-skeleton">
    <div v-for="album in amount" :key="album" class="s-albums-skeleton__album">
      <PSkeleton
        class="s-albums-skeleton__album__image--mobile"
        height="128px"
        width="224px"
      />
      <PSkeleton
        class="s-albums-skeleton__album__image--desktop"
        height="160px"
        width="288px"
      />

      <STextSkeleton class="s-albums-skeleton__album__title" font-size="base" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PSkeleton from "@/atoms/PSkeleton.vue";
import STextSkeleton from "@/atoms/STextSkeleton.vue";

withDefaults(defineProps<{ amount?: number }>(), { amount: 3 });
</script>

<style scoped lang="postcss">
.s-albums-skeleton {
  @apply flex overflow-scroll gap-6;

  &__album {
    @apply flex flex-col gap-2;

    &__title {
      @apply pb-1;
    }

    &__image {
      &--desktop {
        @apply hidden;
      }

      @screen 700 {
        &--mobile {
          @apply hidden;
        }
        &--desktop {
          @apply block;
        }
      }
    }
  }
}
</style>
